import { ControlType, FormFieldBase } from './form-field-base.model';

export class SelectFormField extends FormFieldBase<string> {
  controlType: ControlType = 'select';
}
